<template>
	<div>
		<action-sidebar
			title="Integraciones"
			:value="value"
			@close-modal="closeModal"
		>
		<v-layout wrap pa-5>
			<v-flex xs12 mt-5>
				<label>Integraciones Agregadas</label>
				<v-select
					solo
					multiple
					box
					chips
					hide-details
					:disabled="true"
					class="body-1 mt-2"
					background-color="white"
					item-text="name"
					item-value="id"
					label="Integraciones"
					:items="integrations"
					v-model="model.integrations"
					return-object
				></v-select>
			</v-flex>
			<v-flex xs12 mt-5>
					<label>Integraciones</label>
					<v-select
					solo
					multiple
					box
					chips
					hide-details
					class="body-1 mt-2"
					background-color="white"
					item-text="name"
					item-value="id"
					label="Integraciones"
					:items="integrationsList"
					v-model="model.integrationsList"
					return-object
					></v-select>
				</v-flex>
		</v-layout>
			<section class="modal-filter-footer">
				<modal-sidebar-button
					:on-run-service="loading"
					@cancel-button-clicked="closeModal"
				/>
			</section>
		</action-sidebar>
	</div>
</template>
<script>
import actionSidebar from '@/components/shared/action-sidebar';

function created() {
	this.editCompany();
	this.loadIntegrations();
	this.allIntegrations();
}

function closeModal() {
	this.loading = true;
	this.goTo('page-company', { params: { codeProject: this.codeProject } });
	this.loading = false;
}

async function editCompany() {
	const response = await this.loadData(`project/${this.codeProject}/companies`);
	this.model.integrations = response.records.data[0].template.data.integrations.integrations;
}

async function loadIntegrations() {
	try {
		const response = await this.loadData(`project/${this.codeProject}/companies`);
		this.integrations = [...response.records.data[0].template.data.integrations.integrations];
		// console.log('INTEGRAR', this.integrations);
	} catch (error) {
		this.showNotification('El template no tiene integraciones');
	}
}

async function allIntegrations() {
	try {
		const url = 'integrations';
		const dataResponse = await this.$http.get(url);
		this.integrationsList = [...dataResponse.data.data];
	} catch (error) {
		this.showError();
	}
}

function sendData() {
	// const idsIntegration = this.model.integrations ?
	// 	this.model.integrations.map(integration => integration.id) : [];
	// const body = {
	// 	name: this.data.name,
	// 	integrations: idsIntegration,
	// };
	// Consumir servicio put para enviar los datos
	// Construcción de Json para pasar por el patch
	// Consumir servicio patch para editar registros
}

function data() {
	return {
		data: {},
		loading: false,
		value: true,
		model: {
			name: '',
			integrations: [],
			integrationsList: [],
		},
		integrations: [],
		integrationsList: [],
	};
}

export default {
	name: 'page-company-integrations',
	created,
	components: {
		actionSidebar,
	},
	data,
	methods: {
		closeModal,
		editCompany,
		loadIntegrations,
		allIntegrations,
		sendData,
	},
	props: {
		codeProject: {
			type: String,
		},
		codeCompany: {
			type: String,
		},
	},
	watch: {
		$route(newVal) {
			if (newVal) {
				if (newVal.name === 'page-company-integrations') {
					this.loadData(`project/${this.codeProject}/companies`);
				}
			}
		},
	},
};
</script>


// WEBPACK FOOTER //
// src/pages/companies/page-company-integrations.vue